var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirmationlayout"},[_c('span',{staticClass:"logintext"},[_vm._v(_vm._s(_vm.$t('Login.SignUp.CHECKING_YOUR_EMAIL_DESC')))]),_c('br'),(_vm.loading)?_c('v-progress-linear',{attrs:{"color":"primary","indeterminate":"","rounded":"","height":"6"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }